import {Component, Inject, OnInit} from '@angular/core';
import {Favorite} from '@models/favorite';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {AdService} from '@services/ad.service';

@Component({
  selector: 'app-edit-annexe',
  templateUrl: './edit-annexe.component.html',
  styleUrls: ['./edit-annexe.component.scss']
})
export class EditAnnexeComponent {

    favorite: Favorite;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public adService: AdService,
        public dialogRef: MatDialogRef<EditAnnexeComponent>) {
        this.favorite = Object.assign({}, data.favorite);
    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }

    onYesClick(): void {
        this.favorite = this.adService.updateValues(this.favorite);
        this.dialogRef.close(this.favorite);
    }

}
